//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { FacebookPageActions } from '@facebook/actions/facebookPageActions';
import { FACEBOOK_PAGE_ACTIONS } from '@facebook/constants/facebookConstants';
import { IFacebookPageDetails } from '@facebook/models/facebookPostDetailsModel';

const initialState: IFacebookPageDetails = {
  pageMetadata: {
    biography: undefined,
    profilePictureUrl: undefined,
    username: undefined,
  },
  taggedPages: {
    data: {},
    invalidPages: {},
  },
  isClientOnboarded: undefined,
  flags: {
    hasMissingPageId: false,
    isFetchingPageMetadata: false,
    isFetchingFacebookAndInstagramConnectionInfo: true,
    isFetchingFacebookPageConnectionInfo: false,
    isSettingOnboarded: false,
  },
};

export default function FacebookPageReducer(
  state: IFacebookPageDetails = initialState,
  action: FacebookPageActions,
): IFacebookPageDetails {
  switch (action.type) {
    case FACEBOOK_PAGE_ACTIONS.REQUEST_PAGE_METADATA: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingPageMetadata: true,
        },
      };
    }
    case FACEBOOK_PAGE_ACTIONS.RECEIVE_PAGE_METADATA: {
      return {
        ...state,
        pageMetadata: action.pageMetadata,
        flags: {
          ...state.flags,
          isFetchingPageMetadata: false,
        },
      };
    }
    case FACEBOOK_PAGE_ACTIONS.REQUEST_FB_IG_CONNECTION_INFO: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingFacebookAndInstagramConnectionInfo: true,
        },
      };
    }
    case FACEBOOK_PAGE_ACTIONS.RECEIVE_FB_IG_CONNECTION_INFO_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingFacebookAndInstagramConnectionInfo: false,
        },
      };
    }
    case FACEBOOK_PAGE_ACTIONS.RECEIVE_FB_IG_CONNECTION_INFO_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingFacebookAndInstagramConnectionInfo: false,
        },
      };
    }
    case FACEBOOK_PAGE_ACTIONS.REQUEST_FACEBOOK_PAGE_CONNECTION_INFO: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingFacebookPageConnectionInfo: true,
        },
      };
    }
    case FACEBOOK_PAGE_ACTIONS.RECEIVE_FACEBOOK_PAGE_CONNECTION_INFO_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingFacebookPageConnectionInfo: false,
        },
        isClientOnboarded: action.isClientOnboarded,
      };
    }
    case FACEBOOK_PAGE_ACTIONS.RECEIVE_FACEBOOK_PAGE_CONNECTION_INFO_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingFacebookPageConnectionInfo: false,
        },
      };
    }
    case FACEBOOK_PAGE_ACTIONS.REQUEST_SET_IS_ONBOARDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSettingOnboarded: true,
        },
        isClientOnboarded: initialState.isClientOnboarded,
      };
    }
    case FACEBOOK_PAGE_ACTIONS.RECEIVE_SET_IS_ONBOARDED_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSettingOnboarded: false,
        },
        isClientOnboarded: true,
      };
    }
    case FACEBOOK_PAGE_ACTIONS.RECEIVE_SET_IS_ONBOARDED_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isSettingOnboarded: false,
        },
      };
    }

    case FACEBOOK_PAGE_ACTIONS.RECEIVE_TAGGED_PAGE: {
      return {
        ...state,
        taggedPages: {
          ...state.taggedPages,
          data: { ...state.taggedPages.data, ...action.page },
        },
      };
    }
    case FACEBOOK_PAGE_ACTIONS.RECIEVE_GET_PAGE_BY_ID_FAILED: {
      return {
        ...state,
        taggedPages: {
          ...state.taggedPages,
          invalidPages: {
            ...state.taggedPages.invalidPages,
            [action.pageId]: action.failureMessage,
          },
        },
      };
    }
    default:
      return state;
  }
}
